import styled from "styled-components";

const NavBarContainer = styled.div`
  ${(props) =>
    props.shadow &&
    `
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
  `};
  width: 100%;
  height: 70px;
  position: fixed;
  transition: 0.2s;
  display: flex;
  top: 0;
  background-color: ${({ theme }) => theme.colors.white};
  transition: box-shadow 0.3s ease-in-out;
  z-index: 99;
`;

export default NavBarContainer;
